module.exports = __webpack_public_path__ + "static/drive2-55961f7a5ba7b3d8b91c73aebed00f89.jpg";